import FiltersWrapper from './filtersWrapper';

export default FiltersWrapper;
